import { StageUnit } from '../views/LabelBuilder/LabelBuilder.slice'

type Unit = StageUnit

export default {
  pixelToInch (pixel: number) {
    const dpi = 96
    return pixel / dpi
  },

  inchToPixel (inch: number) {
    const dpi = 96
    return dpi * inch
  },

  millimeterToPixel (millimeter: number) {
    const inch = this.millimeterToInch(millimeter)
    return this.inchToPixel(inch)
  },

  millimeterToInch (millimeter: number) {
    return millimeter / 25.4
  },

  unitToInch (unit: Unit, value: number) {
    switch (unit) {
      case 'px': {
        return this.pixelToInch(value)
      }
      case 'mm': {
        return this.millimeterToInch(value)
      }
      default: {
        return value
      }
    }
  },

  unitToPixel (unit: Unit, value: number) {
    switch (unit) {
      case 'in': {
        return this.inchToPixel(value)
      }
      case 'mm': {
        return this.millimeterToPixel(value)
      }
      default: {
        return value
      }
    }
  }
}
